export const longRequestTimeout = 120000;  // 2min.
export const requestTimeout = 60000;
export const loadQuestionsTimeout = 20000;
export const generalExceptionKey = 'app.error.general.exception';
